import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.company) this.$company = options.company
    else if (options.parent && options.parent.$company)
      this.$company = options.parent.$company
  },
})

export default {
  async getCompanies() {
    const response = await http.get(`/companies`)
    return response.data
  },
}
